/* The Hide Master — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const money = (cents) => {
    const cfg = window.HM || {};
    const fmt = cfg.moneyFormat || '${{amount}}';
    let amount = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    if (cfg.hideDecimals && amount.endsWith('.00')) amount = amount.slice(0, -3);
    let out = fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    if (cfg.rupeeSymbol) out = out.replace(/Rs\.?/g, '₹').replace(/INR/g, '₹').replace(/₹\s+/g, '₹');
    return out;
  };

  /* ---------------- Overlay + body lock ---------------- */
  const overlay = () => $('[data-overlay]');
  function lock(on) {
    document.body.classList.toggle('is-locked', on);
    const o = overlay();
    if (o) o.classList.toggle('is-open', on);
  }
  function closeAll() {
    $$('.drawer.is-open, .search-drawer.is-open, .modal.is-open').forEach((el) => {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    lock(false);
  }
  function open(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    lock(true);
    const focusable = el.querySelector('input, button, a');
    if (focusable) setTimeout(() => focusable.focus(), 120);
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      open($(opener.dataset.open));
      return;
    }
    if (e.target.closest('[data-close]') || e.target.hasAttribute('data-overlay')) closeAll();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* ---------------- Sticky header ---------------- */
  const headerWrap = $('[data-header]');
  if (headerWrap) {
    // A spacer keeps the page from jumping when the header switches to fixed.
    const spacer = document.createElement('div');
    spacer.className = 'header-spacer';
    headerWrap.parentNode.insertBefore(spacer, headerWrap.nextSibling);

    let trigger = 0;
    const measure = () => {
      const wasFixed = headerWrap.classList.contains('is-fixed');
      if (wasFixed) headerWrap.classList.remove('is-fixed');
      trigger = headerWrap.offsetTop;
      spacer.style.height = headerWrap.offsetHeight + 'px';
      if (wasFixed) headerWrap.classList.add('is-fixed');
    };

    const onScroll = () => {
      const pinned = window.scrollY > trigger;
      headerWrap.classList.toggle('is-fixed', pinned);
      spacer.classList.toggle('is-active', pinned);
      headerWrap.classList.toggle('is-stuck', window.scrollY > trigger + 8);
    };

    measure();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => { measure(); onScroll(); });
    window.addEventListener('load', () => { measure(); onScroll(); });
  }

  /* ---------------- Scroll reveal ---------------- */
  let io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$('.reveal').forEach((el) => io.observe(el));
  } else {
    $$('.reveal').forEach((el) => el.classList.add('is-visible'));
  }
  document.addEventListener('sections:reload', () => {
    initSliders();
    if (io) $$('.reveal:not(.is-visible)').forEach((el) => io.observe(el));
    else $$('.reveal').forEach((el) => el.classList.add('is-visible'));
  });

  /* ---------------- Hero parallax ---------------- */
  const parallax = $$('[data-parallax] img');
  if (parallax.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        parallax.forEach((img) => {
          const rect = img.parentElement.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top < window.innerHeight) {
            img.style.transform = 'scale(1.08) translate3d(0,' + (rect.top * -0.06).toFixed(2) + 'px,0)';
          }
        });
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------------- Sliders ---------------- */
  function initSliders(scope) {
    $$('[data-slider-root]', scope).forEach((root) => {
      if (root.dataset.sliderReady) return;
      root.dataset.sliderReady = '1';
    const track = $('[data-slider]', root);
    const prev = $('[data-slider-prev]', root);
    const next = $('[data-slider-next]', root);
    const bar = $('[data-slider-progress] span', root);
    if (!track) return;
    const step = () => track.firstElementChild ? track.firstElementChild.offsetWidth + 28 : 300;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft < 8;
      if (next) next.disabled = track.scrollLeft >= max - 8;
      if (bar) {
        const visible = track.clientWidth / track.scrollWidth;
        bar.style.width = (visible * 100).toFixed(2) + '%';
        bar.style.left = (max > 0 ? (track.scrollLeft / max) * (100 - visible * 100) : 0).toFixed(2) + '%';
      }
    };
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  initSliders();

  /* ---------------- Cart ---------------- */
  const cartDrawer = () => $('#CartDrawer');

  function renderCart(cart) {
    const drawer = cartDrawer();
    if (!drawer) return;
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    const body = $('[data-cart-items]', drawer);
    const foot = $('[data-cart-foot]', drawer);
    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty"><p class="lede">Your bag is empty.</p><a class="btn mt-24" href="/collections/all">Shop the collection</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    body.innerHTML = cart.items.map((item, i) => `
      <div class="cart-item" data-line="${i + 1}">
        <a class="cart-item__img" href="${item.url}">
          <img src="${item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_240x$1') : ''}" alt="${item.product_title}" loading="lazy" width="88" height="110">
        </a>
        <div>
          <a class="cart-item__title" href="${item.url}">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          ${(item.properties && Object.keys(item.properties).length)
            ? Object.entries(item.properties).filter(([k]) => k.charAt(0) !== '_')
                .map(([k, v]) => `<div class="cart-item__variant">${k}: ${v}</div>`).join('')
            : ''}
          <div class="cart-item__foot">
            <div class="qty">
              <button type="button" data-qty="-1" aria-label="Reduce quantity">−</button>
              <input type="number" value="${item.quantity}" min="0" data-qty-input aria-label="Quantity">
              <button type="button" data-qty="1" aria-label="Increase quantity">+</button>
            </div>
            <span class="price"><span class="price__current">${money(item.final_line_price)}</span></span>
          </div>
          <button type="button" class="cart-item__remove" data-remove>Remove</button>
        </div>
      </div>`).join('');

    const subtotal = $('[data-cart-subtotal]', drawer);
    if (subtotal) subtotal.textContent = money(cart.total_price);
    updateShipBar(cart.total_price);
  }

  function updateShipBar(total) {
    const threshold = (window.HM && window.HM.freeShippingThreshold) || 0;
    $$('[data-ship-bar]').forEach((bar) => {
      if (!threshold) { bar.hidden = true; return; }
      bar.hidden = false;
      const remaining = Math.max(threshold - total, 0);
      const text = $('[data-ship-text]', bar);
      const fill = $('[data-ship-fill]', bar);
      if (fill) fill.style.width = Math.min((total / threshold) * 100, 100) + '%';
      if (text) {
        text.textContent = remaining > 0
          ? `You're ${money(remaining)} away from complimentary shipping.`
          : 'Complimentary shipping unlocked.';
      }
    });
  }

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function changeLine(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    return res.json();
  }

  async function addToCart(formData, button) {
    const original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const isJson = Array.isArray(formData);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: isJson ? JSON.stringify({ items: formData }) : formData,
        headers: isJson
          ? { 'Content-Type': 'application/json', Accept: 'application/json' }
          : { Accept: 'application/json' }
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message);
      const cart = await fetchCart();
      renderCart(cart);
      closeAll();
      open(cartDrawer());
      if (button) button.textContent = 'Added';
      setTimeout(() => { if (button) { button.textContent = original; button.disabled = false; } }, 1400);
    } catch (err) {
      if (button) { button.textContent = original; button.disabled = false; }
      const note = button ? button.closest('form') && $('[data-form-error]', button.closest('form')) : null;
      if (note) { note.textContent = err.message; note.hidden = false; }
      else alert(err.message);
    }
  }

  function buildPayload(form) {
    const fd = new FormData(form);
    const toggle = $('[data-personalize-toggle]', form);
    const addonId = toggle && toggle.dataset.personalizationVariant;
    if (!toggle || !toggle.checked || !addonId) return fd;

    // Personalization is a separate paid product, so send both lines in one request.
    const properties = {};
    fd.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && String(value).trim() !== '') properties[match[1]] = value;
    });
    const items = [
      { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1), properties }
    ];
    items.push({
      id: Number(addonId),
      quantity: Number(fd.get('quantity') || 1),
      properties: { _linked_to: properties.Personalization || 'Personalization' }
    });
    return items;
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    addToCart(buildPayload(form), $('[type="submit"]', form));
  });

  document.addEventListener('click', async (e) => {
    const drawer = cartDrawer();
    const qtyBtn = e.target.closest('[data-qty]');
    const removeBtn = e.target.closest('[data-remove]');
    if (!drawer || (!qtyBtn && !removeBtn)) return;
    const item = e.target.closest('[data-line]');
    if (!item || !drawer.contains(item)) return;
    const line = parseInt(item.dataset.line, 10);
    const input = $('[data-qty-input]', item);
    let qty = 0;
    if (qtyBtn) qty = Math.max(parseInt(input.value, 10) + parseInt(qtyBtn.dataset.qty, 10), 0);
    renderCart(await changeLine(line, qty));
  });

  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-qty-input]');
    const drawer = cartDrawer();
    if (!input || !drawer || !drawer.contains(input)) return;
    const item = input.closest('[data-line]');
    renderCart(await changeLine(parseInt(item.dataset.line, 10), Math.max(parseInt(input.value, 10) || 0, 0)));
  });

  if (cartDrawer()) fetchCart().then(renderCart);

  /* ---------------- Quick add ---------------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.quickAdd;
    if (btn.dataset.variantId) {
      const fd = new FormData();
      fd.append('id', btn.dataset.variantId);
      fd.append('quantity', 1);
      addToCart(fd, btn);
      return;
    }
    const modal = $('#QuickAdd');
    if (!modal) return;
    const body = $('[data-quick-add-body]', modal);
    body.innerHTML = '<p class="lede">Loading options…</p>';
    open(modal);
    try {
      const res = await fetch(`/products/${handle}?section_id=quick-add`);
      body.innerHTML = new DOMParser().parseFromString(await res.text(), 'text/html').querySelector('.shopify-section').innerHTML;
    } catch (err) {
      body.innerHTML = '<p class="lede">This product could not be loaded. Open the product page to continue.</p>';
    }
  });

  /* ---------------- Predictive search ---------------- */
  const searchDrawer = $('#SearchDrawer');
  if (searchDrawer) {
    const input = $('[data-search-input]', searchDrawer);
    const results = $('[data-search-results]', searchDrawer);
    const defaults = $('[data-search-default]', searchDrawer);
    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) {
        results.innerHTML = '';
        if (defaults) defaults.hidden = false;
        return;
      }
      timer = setTimeout(async () => {
        if (defaults) defaults.hidden = true;
        results.innerHTML = '<p class="lede">Searching…</p>';
        try {
          const url = `/search/suggest?q=${encodeURIComponent(q)}&resources[type]=product,collection,page&resources[limit]=8&section_id=predictive-search`;
          const res = await fetch(url);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          results.innerHTML = doc.querySelector('.shopify-section').innerHTML;
        } catch (err) {
          results.innerHTML = '<p class="lede">Search is unavailable right now. Press Enter to see all results.</p>';
        }
      }, 260);
    });
  }

  /* ---------------- Wishlist (localStorage) ---------------- */
  const WKEY = 'hm:wishlist';
  const readWish = () => { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } };
  const writeWish = (list) => { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {} };
  function paintWish() {
    const list = readWish();
    $$('[data-wishlist]').forEach((btn) => {
      const on = list.includes(btn.dataset.wishlist);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on);
    });
    $$('[data-wishlist-count]').forEach((el) => { el.textContent = list.length; el.hidden = list.length === 0; });
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.wishlist;
    const list = readWish();
    const i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    writeWish(list);
    paintWish();
    document.dispatchEvent(new CustomEvent('wishlist:change'));
  });
  paintWish();

  /* ---------------- Localization dropdown ---------------- */
  /* The country buttons are native submit buttons, so switching currency needs no JS.
     This only powers the search filter and focus. */
  $$('[data-localization]').forEach((root) => {
    const search = $('[data-localization-search]', root);
    if (!search) return;
    search.addEventListener('input', () => {
      const q = search.value.toLowerCase();
      $$('[data-localization-item]', root).forEach((item) => {
        const li = item.closest('li') || item;
        li.hidden = !item.dataset.localizationItem.toLowerCase().includes(q);
      });
    });
    root.addEventListener('toggle', () => {
      if (root.open) setTimeout(() => search.focus(), 60);
    });
  });
  document.addEventListener('click', (e) => {
    $$('[data-localization][open]').forEach((d) => { if (!d.contains(e.target)) d.open = false; });
  });

  /* ---------------- Product gallery ---------------- */
  $$('[data-gallery]').forEach((gallery) => {
    const slides = $('[data-gallery-slides]', gallery);
    const thumbs = $$('[data-gallery-thumb]', gallery);
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const target = $$('.gallery__slide', slides)[parseInt(thumb.dataset.galleryThumb, 10)];
        if (target) slides.scrollTo({ left: target.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
      });
    });
    const dots = $$('[data-gallery-dot]', gallery);
    slides.addEventListener('scroll', () => {
      const i = Math.round(slides.scrollLeft / slides.clientWidth);
      thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i));
      dots.forEach((d, n) => d.setAttribute('aria-current', n === i));
    }, { passive: true });
    $$('.gallery__slide img', slides).forEach((img) => {
      img.addEventListener('click', () => img.classList.toggle('is-zoomed'));
    });
  });

  /* ---------------- Variant selection ---------------- */
  $$('[data-variant-form]').forEach((form) => {
    const data = JSON.parse($('[data-variant-json]', form).textContent);
    const idField = $('[name="id"]', form);
    const priceEl = $('[data-variant-price]', form);
    const submit = $('[type="submit"]', form);
    form.addEventListener('change', () => {
      const chosen = $$('[data-option-index]', form)
        .filter((i) => i.checked || i.tagName === 'SELECT')
        .map((i) => i.value);
      const variant = data.find((v) => v.options.every((opt, i) => opt === chosen[i]));
      if (!variant) return;
      idField.value = variant.id;
      if (priceEl) priceEl.innerHTML = money(variant.price) +
        (variant.compare_at_price > variant.price ? ` <s class="price__compare">${money(variant.compare_at_price)}</s>` : '');
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? submit.dataset.available : 'Sold out';
      }
      if (window.history.replaceState) {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      const slide = $(`[data-media-id="${variant.featured_media_id}"]`);
      if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  });

  /* ---------------- Sticky add to cart ---------------- */
  const sticky = $('[data-sticky-atc]');
  const mainAtc = $('[data-main-atc]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      const on = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', on);
      document.body.classList.toggle('has-sticky-atc', on);
    }, { threshold: 0 }).observe(mainAtc);
  }

  /* ---------------- Personalization toggle ---------------- */
  $$('[data-personalize-toggle]').forEach((toggle) => {
    const field = $(toggle.dataset.personalizeToggle);
    const sync = () => { if (field) field.hidden = !toggle.checked; };
    toggle.addEventListener('change', sync);
    sync();
  });

  /* ---------------- Personalisation character counter ---------------- */
  $$('[data-perso-input]').forEach((input) => {
    const out = $(input.dataset.persoInput);
    const sync = () => { if (out) out.textContent = input.value.length + ' / ' + input.maxLength; };
    input.addEventListener('input', sync);
    sync();
  });

  /* ---------------- Dismissible announcement ---------------- */
  $$('[data-announcement-close]').forEach((btn) => {
    const bar = btn.closest('.announcement');
    try { if (sessionStorage.getItem('hm:announce') === 'off') bar.hidden = true; } catch (e) {}
    btn.addEventListener('click', () => {
      bar.hidden = true;
      try { sessionStorage.setItem('hm:announce', 'off'); } catch (e) {}
      window.dispatchEvent(new Event('resize'));
    });
  });

  /* ---------------- Video block ---------------- */
  $$('[data-video-play]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const root = btn.closest('[data-video]');
      const src = root.dataset.video;
      if (!src) return;
      root.innerHTML = '<div class="videoblock__media"><iframe src="' + src +
        '" title="Video" allow="autoplay; encrypted-media; fullscreen" allowfullscreen frameborder="0" style="width:100%;height:100%"></iframe></div>';
    });
  });
})();
